module.exports = __webpack_public_path__ + "335777d5.webp";